type TitleCaseOptions = {
    ignoreWords: string[]
    splitOnDash: boolean
    splitOnSpace: boolean
    additionalSplitters: string[]
}

declare global {
    interface String {
        toTitleCase(options?: Partial<TitleCaseOptions>): String
        upperCaseFirst(): String
    }
}

String.prototype.upperCaseFirst = function() {
    return this.charAt(0).toUpperCase() + this.slice(1)
}

String.prototype.toTitleCase = function (options: Partial<TitleCaseOptions> = {}) {
    const defaultOptions: TitleCaseOptions = {
        ignoreWords: [],
        additionalSplitters: [],
        splitOnDash: false,
        splitOnSpace: true
    }

    const finalOptions = {
        ...defaultOptions,
        ...options
    }

    const ucFirst = (word: string) => {
        if (finalOptions.ignoreWords.length == 0 || finalOptions.ignoreWords.some(ignored => ignored != word))
            return word.upperCaseFirst()

        return word
    }

    const splitters = finalOptions.additionalSplitters

    if (finalOptions.splitOnDash)
        splitters.push("-")

    if (finalOptions.splitOnSpace)
        splitters.push(" ")

    let output = this
    output = output.toLowerCase()
    output = output.upperCaseFirst()

    splitters.distinct()
        .forEach(splitter => {
            output = output.split(splitter)
                .map(ucFirst)
                .join(splitter)
        })

    return output
}

export {}
